export default "__VITE_ASSET__Y38JupsD__"